import * as AT from './_types'
import fetchApi from '../../services/fetchApi'
import { logException } from '../../services/sentry'

export const recieveApptTypes = appointmentTypes => (dispatch) => {
  dispatch({
    type: AT.APPT_TYPES_LIST,
    appointmentTypes,
  })
}

export const fetchApptTypes = isFetchAll => (dispatch) => {
  dispatch({ type: AT.APPT_TYPES_FETCHING })
  const params = {}
  if (isFetchAll) params.all = true
  const searchParams = new URLSearchParams(params)
  fetchApi(`/appointment_types?${searchParams}`, 'GET')
    .then(({ appointment_types: appointmentTypes }) => {
      dispatch({
        type: AT.APPT_TYPES_LIST,
        appointmentTypes,
      })
      dispatch({ type: AT.APPT_TYPES_FETCHED })
    })
    .catch((err) => {
      logException(err)
    })
}

export const patchApptType = (
  apptTypeId,
  apptVisibility,
  window,
) => (dispatch) => {
  dispatch({ type: AT.APPT_TYPES_FETCHING })
  const body = JSON.stringify({
    visibility: apptVisibility,
    id: apptTypeId,
    window,
  })
  fetchApi('/appointment_types', 'PATCH', { body })
    .then(() => {
      dispatch(fetchApptTypes(false))
    })
    .catch((err) => {
      logException(err)
    })
}



// WEBPACK FOOTER //
// ./src/state/actions/appointment-types.js